export default __webpack_public_path__ + "static/43-100-9e25e2d70a419bccc0c58a18c236bae6.jpg";